import { Card } from 'react-bootstrap';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import OrganizationDetails from 'components/global/OrganizationsList/components/OrganizationDetails';
import { fetchOrganization } from 'components/global/OrganizationsList/OrganizationsList.helpers';
import BreadCrumbWrapper from 'components/global/BreadCrumbs/BreadCrumbs';
import { organizationDetailsSignal } from 'components/global/OrganizationsList/OrganizationsList.signal';
import { checkEdoPermissionsAcrossPrograms } from '../../../../libs/edoPermissions';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import api from '../../../../api/api';
import loaderSignal from '../../../../signals/Loader.signal';

const EdoLenderDetail = () => {
  const { pathname } = useLocation();
  const segments = pathname.split('/');
  const organizationId = segments[segments.length - 1];
  const signalOrg = organizationDetailsSignal.value.selectedOrganization;
  const [selectedOrganization, setSelectedOrganization] = useState(signalOrg);
  const [canViewMaintenance, setCanViewMaintenance] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (signalOrg && signalOrg.id === Number(organizationId)) {
      setSelectedOrganization(signalOrg);
    }
  }, [signalOrg, organizationId]);

  let labels = [];

  if (pathname.startsWith('/edo/portfolio')) {
    const applicationId = Number(segments[3]);

    const fundingProgramMembership =
      selectedOrganization?.fundingProgramMemberships?.find((fpm) =>
        fpm.applications?.some((app) => app.id === applicationId)
      );

    const application = fundingProgramMembership?.applications?.find(
      (app) => app.id === applicationId
    );

    labels = [
      '',
      !!application ? `${selectedOrganization?.name} - ${application?.business.name}` : '',
      selectedOrganization?.name || '',
    ];
  } else {
    labels = [
        '',
        selectedOrganization?.name,
      ];
  }

  useEffect(() => {
    const checkViewMaintenancePermission = async () => {
      try {
        setIsChecking(true);
        loaderSignal.update({ isContentLoading: true });
        const userData = userAccountSignal.value.userData;
        
        if (!userData) {
          setIsChecking(false);
          loaderSignal.reset();
          return;
        }

        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userData?.account.edoId,
            },
          },
        });

        const permissions = await checkEdoPermissionsAcrossPrograms(
          fundingPrograms,
          ['canViewMaintenance']
        );
        setCanViewMaintenance(permissions.canViewMaintenance);
      } catch (error) {
        console.error('Error checking view maintenance permission:', error);
        setCanViewMaintenance(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkViewMaintenancePermission();
  }, [userAccountSignal.value.userData]);

  const init = useCallback(async () => {
    if (canViewMaintenance) {
      await fetchOrganization(organizationId, '/lenders');
    }
  }, [organizationId, canViewMaintenance]);

  useEffect(() => {
    init();
  }, [init]);

  if (isChecking) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <Card>
          <Card.Body>
            <p className="text-center">Loading...</p>
          </Card.Body>
        </Card>
      </BreadCrumbWrapper>
    );
  }

  if (!canViewMaintenance) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <Card>
          <Card.Body>
            <h3 className="text-center">Access Denied</h3>
            <p className="text-center">
              You do not have permission to view lender details.
            </p>
          </Card.Body>
        </Card>
      </BreadCrumbWrapper>
    );
  }

  return (
    <BreadCrumbWrapper labels={labels}>
      <Card>
        <Card.Body>
          <OrganizationDetails showLinkToPrograms={!pathname.startsWith('/edo/portfolio')} />
        </Card.Body>
      </Card>
    </BreadCrumbWrapper>
  );
};

export default EdoLenderDetail;
